module.exports = __webpack_public_path__ + "static/media/hamburger.1a13003e.svg";